module.exports = __webpack_public_path__ + "img/image5.458b43bd.png";